var map = {
	"./10.png": 526,
	"./11.png": 527,
	"./12.png": 528,
	"./13.png": 529,
	"./14.png": 530,
	"./15.png": 531,
	"./16.png": 532,
	"./17.png": 533,
	"./18.png": 534,
	"./19.png": 535,
	"./20.png": 536,
	"./21.png": 537,
	"./22.png": 538,
	"./23.png": 539,
	"./24.png": 540,
	"./6.png": 541,
	"./7.png": 542,
	"./8.png": 543,
	"./9.png": 544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 525;